// Story categories are stored on posts as a fixed key ("AI", "making-waves").
// Their display name and optional intro live in the locale files under
// stories.categories.<key>; an unknown key shows as itself.
export const categoryName = (t, key) => t(`stories.categories.${key}.name`, { defaultValue: key });

export const categoryIntro = (t, key) => t(`stories.categories.${key}.intro`, { defaultValue: "" });
